import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { ActivityCardComponent } from 'src/app/shared/activity-card/activity-card.component';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { Activity } from '../activity.model';
import { TakerService } from '../../shared/taker.service';
import { Taker } from '../../taker/taker-profile/taker.model';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../shared/auth.service';
import { ExperienceSearchComponent } from 'src/app/shared/experience-search/experience-search.component';
import { JsonLdService } from 'src/app/json-ld.service';
import { ActivitiesService } from 'src/app/pages/activities/activities.service';

@Component({
  selector: 'app-experiences-page',
  standalone: true,
  imports: [
    TranslateModule,
    ExperienceSearchComponent,
    ActivityCardComponent,
    LoginComponent,
    ModalModule,
    CommonModule,
    InfiniteScrollModule,
  ],
  providers: [ActivitiesService],
  styleUrls: ['./activities-page.component.scss'],
  templateUrl: './activities-page.component.html',
})
export class ActivitiesPageComponent implements OnInit {
  parentVariable: string;
  public expandedIndex = -1;
  public originalActivities: Activity[];
  activities = [];
  takerActivities = [];
  resellerActivities = [];
  shownDays = [
    { value: 0, text: 'Todos los días' },
    { value: 1, text: 'Lun' },
    { value: 2, text: 'Mar' },
    { value: 3, text: 'Mié' },
    { value: 4, text: 'Jue' },
    { value: 5, text: 'Vie' },
    { value: 6, text: 'Sáb' },
    { value: 7, text: 'Dom' },
  ];
  isAlertShown = false;
  throttle = 150;
  scrollDistance = 0.1;
  page = 1;
  total = 0;
  notEmptyExperience = true;
  notScrolly = true;
  loading = false;
  @ViewChild('autoShownModal', { static: false })
  autoShownModal: ModalDirective;
  @Input() childData: string;

  constructor(
    private activityService: ActivitiesService,
    private router: Router,
    private titleService: Title,
    private takerService: TakerService,
    public authService: AuthService,
    public translate: TranslateService,
    private meta: Meta,
    private renderer2: Renderer2,
    private elem: ElementRef,
    private jsonLdService: JsonLdService
  ) {}

  ngOnInit(): void {
    this.removeMetaTags();
    this.loading = true;
    this.titleService.setTitle('Encuentra tu experiencia | Venntur');
    this.router['rawUrlTree'].queryParams['page'] = this.page;
    // this.router['rawUrlTree'].queryParams['page'] = this.page;

    setTimeout(() => {
      this.activityService
        .getActivities(
          this.router['rawUrlTree'].queryParams,
          this.translate.getDefaultLang()
        )
        .pipe(finalize(() => (this.loading = false)))
        .subscribe((activities) => {
          this.total = activities['hydra:totalItems'];
          this.activities = activities['hydra:member'];
          this.addJsonLdSchema();
        });
    }, 1000);
    this.activityService
      .getActivitiesByTakerId(this.takerService.getId())
      .subscribe((activities) => {
        this.takerActivities = Array.from(activities['hydra:member']).map(
          (item) => item['@id']
        );
      });
    this.meta.addTags([
      { name: 'description', content: 'test' },
      { name: 'lang', content: 'es' },
      { name: 'robots', content: 'index, follow' },
      { property: 'og:title', content: 'test' },
      { property: 'og:description', content: 'test' },
      {
        property: 'og:image',
        content: 'https://venntur.com/assets/venntur-isotype-70.png',
      },
      { property: 'og:url', content: 'https://venntur.com/' },
      { property: 'og:site_name', content: 'Venntur' },
    ]);
  }

  clickFavorite(event, experienceId) {
    if (this.takerService.getId()) {
      this.takerActivities.includes(experienceId)
        ? this.takerActivities.splice(
            this.takerActivities.indexOf(experienceId),
            1
          )
        : this.takerActivities.push(experienceId);
      const taker = {
        favoriteActivities: this.takerActivities,
      };
      const editedTaker = new Taker(taker);
      this.takerService
        .putTaker(this.takerService.getId(), editedTaker)
        .subscribe();
    } else {
      this.isAlertShown = true;
    }
  }

  addFavoriteToReseller(event, experienceId) {
    this.resellerActivities.includes(experienceId)
      ? this.resellerActivities.splice(
          this.resellerActivities.indexOf(experienceId),
          1
        )
      : this.resellerActivities.push(experienceId);
  }

  expandText(index: number): void {
    this.expandedIndex = index === this.expandedIndex ? -1 : index;
  }

  onScroll() {
    this.loading = true;
    if (this.notScrolly && this.notEmptyExperience) {
      this.notScrolly = false;
      setTimeout(() => {
        this.loadNextExperience();
      }, 500);
    } else {
      this.loading = false;
    }
  }

  loadNextExperience() {
    // this.router['rawUrlTree'].queryParams['page'] = ++this.page;
    ++this.page;
    let updatedUrl;
    if (this.parentVariable) {
      updatedUrl = this.parentVariable.replace(/page=\d+/, `page=${this.page}`);
    } else if (this.router['rawUrlTree'].queryParams['localidad']) {
      this.router['rawUrlTree'].queryParams['page'] = this.page;
      updatedUrl = this.router['rawUrlTree'];
    } else {
      updatedUrl = '?page=' + this.page;
    }

    let params: any = new URL('https://venntur.com/' + updatedUrl).searchParams;

    if (this.activities.length < this.total) {
      this.activityService
        .getActivitiesByUrl(params, this.translate.getDefaultLang())
        .pipe(finalize(() => (this.loading = false)))
        .subscribe((activities) => {
          this.total = activities['hydra:totalItems'];
          this.activities = this.activities.concat(activities['hydra:member']);
        });
      // let i;
      // const length = this.experiences.length;
      // const experiencePerPage = 9;
      // const experienceToLoad = this.originalExperiences.length - length;

      // if ( experienceToLoad >= experiencePerPage ) {
      //   for (i = length; i <= length + experiencePerPage; i++) {
      //     this.experiences.push(this.originalExperiences[i]);
      //   }
      // } else {
      //   for (i = length; i <= length + experienceToLoad - 1; i++) {
      //     this.experiences.push(this.originalExperiences[i]);
      //   }
      // }
      this.notScrolly = true;
    } else {
      this.notEmptyExperience = false;
      this.loading = false;
    }
  }

  hideModal(): void {
    this.autoShownModal.hide();
  }

  onHidden(): void {
    this.isAlertShown = false;
  }

  changeParentVariable(newVariable: string) {
    this.parentVariable = newVariable;

    const params = new URL('https://venntur.com/' + this.parentVariable)
      .searchParams;

    this.activityService
      .getActivitiesByUrl(params, this.translate.getDefaultLang())
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((activities) => {
        this.total = activities['hydra:totalItems'];
        this.activities = activities['hydra:member'];
        this.page = 1;
      });
  }

  getUrl(isCivitatis, image) {
    // return !isCivitatis ? 'https://dev.venntur.com/assets/experience/files/' + image : image;
    return !isCivitatis
      ? 'https://venntur.com/assets/experience/files/' + image
      : image;
  }

  setCategoryTitle(experience) {
    return experience.categories.map((obj) => obj.name).join(' / ');
  }

  setLanguagesTitle(experience) {
    return experience.languages.map((obj) => obj.name).join(' , ');
  }

  convertTimeToCustomFormat(inputTime: string): string {
    let formattedText;
    const [hours, minutes] = inputTime
      .split(':')
      .map((part) => parseInt(part, 10));

    if (minutes != 0) {
      formattedText = hours + ' h y ' + minutes + ' min';
    } else {
      formattedText = hours + ' h';
    }

    return formattedText;
  }

  shareExperience(experience) {
    var enlace = 'https://venntur.com/product/' + experience.slug;
    var mensaje = this.translate.instant('¡Mira esta experiencia en Venntur!');

    mensaje = encodeURIComponent(mensaje);
    enlace = encodeURIComponent(enlace);

    var enlaceWhatsApp = 'https://wa.me/?text=' + mensaje + '%20' + enlace;

    window.open(enlaceWhatsApp);
  }

  removeMetaTags() {
    const metaTags = this.renderer2
      .selectRootElement('head')
      .querySelectorAll('meta');

    metaTags.forEach((metaTag: Element) => {
      this.renderer2.removeChild(
        this.elem.nativeElement.ownerDocument.head,
        metaTag
      );
    });
  }

  addJsonLdSchema(): void {
    if (this.activities?.length) {
      const schema = this.activities.map((experience) => ({
        '@context': 'https://schema.org',
        '@type': 'TouristAttraction',
        name: experience.name,
        description: experience.description,
        image: experience.images || [],
        url: `https://venntur.com/${this.translate.getDefaultLang()}/product/${
          experience.slug
        }`,
      }));
      this.jsonLdService.setData(schema); // Ensure JSON-LD service is imported and injected
      console.log('JSON-LD schema added:', schema);
    }
  }
}
